import { OfferingTransaction } from '@arrived/models';

import { CANCELLED_TRANSACTION_STATUSES } from '../../constants';

export const isTransactionActive = (transaction: OfferingTransaction): boolean => {
  return transaction.active && !CANCELLED_TRANSACTION_STATUSES.includes(transaction.status);
};
